import { useDealContext } from "src/dm/components/DealLayout/DealLayout";
import DealItems from "src/dm/components/DealItems/DealItems";

const DealItemsPage = () => {
  const deal = useDealContext();
  return (
    <div>
      <h2 style={{ marginTop: 0 }}>Items</h2>
      <DealItems dealId={deal.dealId} />
    </div>
  );
};

export default DealItemsPage;
